'use strict';

angular.module('atex.dam').directive('damPublishLink',['ContentService','AuthenticationService','$q','$timeout', '$state', 'DamService', '$rootScope', '$http', '$translate', 'DamNotificationService', 'configuration', '$window',
  function(ContentService,AuthenticationService,$q,$timeout,$state, DamService, $rootScope, $http, $translate, DamNotificationService, configuration, $window) {
  return {
    restrict: 'EA',
    templateUrl: 'views/dam-publish-link.html',
    replace: true,
    scope: {
      engagement: "=",
      article: '='
    },


    link: function (scope) {

      scope.isVisible =function (buttonName){
        return configuration.getVisiblePublishButtons().includes(buttonName);
      };

      scope.isPublished = function(entry) {
        if (configuration.getEnablePublishedContentShortcutEditMode().includes(scope.article.type) && entry.attributes !== undefined) {
          return entry.attributes.id.startsWith("policy:") || entry.attributes.id.startsWith("ace:");
        } else {
          return false;
        }
      };



      scope.previewPolicyEntry = function(appType, value, openPage) {
        var contentId = atex.dam.AngularUtils.removePolicyPrefix(value);
        DamService.getGalleryUrl(contentId).then(function(galleryUrl) {
          var url = galleryUrl.data+"#device=window&width=840";
          if (openPage){
            $window.open(url, "_blank");
          }else{
            textToClipboard(url);
            notifySuccess();
          }
        });
      };

      scope.copyPublicationLink = function(entry) {
        //if (entry.attributes.id.startsWith("ace:") || !(scope.article && scope.article.data.aspects.contentData.data.objectType.toLowerCase().includes("collection"))){
          getPublicationUrl().then(function(url) {
            textToClipboard(url);
            notifySuccess();
          }, function(error) {
            notifyError(error);
          });
        /*}else if (entry.attributes.id.startsWith("policy:")){
          scope.previewPolicyEntry(entry.appType, entry.attributes.id, false);
        }*/
      };

      scope.openPublicationLink = function(entry) {
        //if (entry.attributes.id.startsWith("ace:") || !(scope.article && scope.article.data.aspects.contentData.data.objectType.toLowerCase().includes("collection"))){
          getPublicationUrl().then(function(url) {
            $window.open(url, '_blank');
          }, function(error) {
            notifyError(error);
          });
          /*}else if (entry.attributes.id.startsWith("policy:")){
          scope.previewPolicyEntry(entry.appType, entry.attributes.id, true);
        }*/
      };

      function textToClipboard (text) {
        var dummy = document.createElement("textarea");
        document.body.appendChild(dummy);
        dummy.value = text;
        dummy.select();
        document.execCommand("copy");
        document.body.removeChild(dummy);
      }


      function getPublicationUrl() {
        var deferred = $q.defer();

          AuthenticationService.getCurrentUser().then(function (currentUser) {
            $window.atex.analytics('event', {e: "get-remote-publication-url", d1: scope.article.id});
            var url = "/onecms/dam/content/publicationUrl/contentid/" + scope.article.id;
            $http({
              method: 'GET',
              url: url,
              headers: {
                'Content-Type': 'text/plain',
                'X-Auth-Token': currentUser.token
              }
            }).then(function (response) {
              deferred.resolve(response.data.url);
            }, function (error) {
              deferred.reject(error);
            });
          });
        return deferred.promise;
      }


      function notifySuccess() {
        DamNotificationService.addNotification(atex.dam.Notification({
          type: 'success',
          message: $translate.getTranslationTable().__OPERATION_COMPLETED_SUCCESSFULLY__
        }), false);
      }

      function notifyError(error) {
        DamNotificationService.addNotification(atex.dam.Notification({
          type: 'error',
          message: $translate.getTranslationTable().__GUI_CLIPBOARD_ERROR__ + error.statusText
        }), true);
      }

      function wash(id) {
        if ((id) && (id.indexOf("policy:") > -1)) {
          id = id.split('policy:')[1];
        }

        return id;
      }
      scope.entries = [];
      scope.busyCursor = false;

      scope.engagement.data.engagementList.forEach(function (engage) {
        var entry = {};

        entry.timestamp = engage.timestamp;
        entry.appType = engage.appType;
        entry.appPk = wash(engage.appPk);
        entry.userName = engage.userName;
        entry.attributes = {};

        engage.attributes.forEach(function (attribute) {
          entry.attributes[attribute.name] = attribute.value;
        });
        scope.entries.push(entry);

        scope.entries = _.filter(scope.entries, function (entry) {
          return entry.attributes['type'] === 'publish';
        });
      });

      scope.setBusyCursor = function(value) {
        //$timeout(function() {
        //});
        $rootScope.$broadcast("dam:busyCursor", value);
        scope.busyCursor = value;
      };

      scope.canCopyToClipboard = function(id) {
        return !id.startsWith('ace:');
      };

      scope.clipboard = function (id) {
        var $temp_input = $("<input>");
        $("body").append($temp_input);
        $temp_input.val(id).select();
        document.execCommand("copy");
        $temp_input.remove();

        if (!scope.canCopyToClipboard(id)) {
          notifySuccess();
          return;
        }

        scope.setBusyCursor(true);

        configuration.whenReady().then(function() {
          scope.adminGUIUrl = configuration.getAdminGUIUrl();
        });

        $http({
          url: scope.adminGUIUrl + '/gui-services/clipboard/add/' + id,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          withCredentials: true
        }).then(function (resp) {
          notifySuccess();
        }).then(null, function(error) {
          console.error(error);
          notifyError(error);
        }).finally(function() {
          scope.setBusyCursor(false);
        });
      };
    }
  };
}]);
